module.exports = __webpack_public_path__ + "img/RegFees-9-welcome.917cc11b.svg";